import React, { FC } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { KTCard } from '../../../../../../_metronic/helpers'
import InputBatchModal from './InputBatchModal'
import { useState } from 'react'
import { KTIcon } from '../../../../../../_metronic/helpers'
interface PrintTagWrapperProps {
    processName: string
    processId: string
}

interface LocationState {
    productionData?: any
}

const PrintTagWrapper: FC<PrintTagWrapperProps> = ({ processName, processId }) => {
    const { productionId } = useParams()
    const location = useLocation() as { state: LocationState }
    const productionData = location.state?.productionData
    const packingBagInfo = productionData?.packingBagInfo || []
    const [showModal, setShowModal] = useState(false)

    return (
        <KTCard>
            <div style={{ marginLeft: "25px", marginRight: "25px" }}>
                <div className="table-responsive">
                    <table
                        id="kt_table_users"
                        className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                    >
                        <thead>
                            <tr style={{
                                backgroundColor: '#333333',
                                color: 'white',
                                fontFamily: 'Inter, Arial, sans-serif',
                                fontSize: '12.32px',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                            }}>
                                <th style={{
                                    padding: '15px 15px 15px 0',
                                    textAlign: 'left',
                                    borderBottom: '1px dotted #dee2e6',
                                }}>
                                    S.N
                                </th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>PRODUCTION ID</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>DATE & TIME</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>CATEGORY</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>ITEM</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>WEIGHT</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>BAG NO</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>BATCH TAG</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>INPUT BATCHf</th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {packingBagInfo && packingBagInfo.length > 0 ? (
                                packingBagInfo.map((bag: any, index: number) => (
                                    <tr key={bag.bagId || index} style={{ backgroundColor: 'white' }}>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>{index + 1}</td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {bag.orderId}
                                        </td>
                                        <td style={{ padding: '20px 12px', fontWeight: '500', borderBottom: '1px dotted #dee2e6' }}>
                                            {bag.createdAt}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {bag.categoryName}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {bag.itemName}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {parseFloat(bag.weight).toFixed(2)}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {bag.bagId}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            <KTIcon iconName='code' className='fs-3' />
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            <span
                                                onClick={() => setShowModal(true)}
                                                style={{
                                                    color: '#007bff',
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline'
                                                }}
                                            >
                                                View
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={8} className="text-center" style={{ padding: '20px 12px', color: "gray" }}>
                                        No record found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <InputBatchModal
                show={showModal}
                onHide={() => setShowModal(false)}
                productionData={productionData}
            />
        </KTCard>
    )
}

export { PrintTagWrapper }